import store from '@/store';

export default async (to) => {
    await store.dispatch('category/RESET_CURRENT_CATEGORY');
    const categorySlug = to.params.categorySlug;
    if (!_.isEmpty(categorySlug)) {
        await store.dispatch('category/FETCH_CURRENT_CATEGORY', categorySlug);
    }
};
